import React, { Component } from 'react';
import classnames from 'classnames';
import { FormControl, TextField, InputAdornment, IconButton } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import { debounce } from 'lodash';

import APSearchInputStyle from './styles/APSearchInput.style';
import { ReactComponent as SearchIcon } from '../../atoms/APReferralsSearchBar/assets/searchIcon.svg';
import { ReactComponent as APCloseIcon } from './assets/closeIcon.svg';

interface APSearchInputProps extends WithStyles<typeof APSearchInputStyle> {
  resetData: Function,
  hideSearchBar: Function,
  getSearchResults: Function,
  className?: string
}

class APSearchInput extends Component<APSearchInputProps, {}> {
  searchBar: any;
  method = debounce(() => {
    this.getSearchResults();
  });

  state = {
    touched: false,
    searchValue: ''
  };

  constructor(props: any) {
    super(props);
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
    this.method = debounce(this.method.bind(this), 500);
    this.searchBar = React.createRef();
  }

  onChange(evt: any) {
    const { value } = evt.target;
    this.setState({ searchValue: value }, () => {
      this.method();
    });
  }

  onBlur() {
    this.setState({
      searchValue: ''
    }, () => {
      const { resetData, hideSearchBar } = this.props;
      if (resetData) {
        resetData();
        hideSearchBar();
      }
    });
  }

  getSearchResults = () => {
    const { getSearchResults } = this.props;
    const { searchValue } = this.state;
    if (searchValue !== '') {
      getSearchResults(searchValue);
    }
  }
  componentDidMount() {
    this.searchBar.current.focus();
  }

  render() {
    const {
      classes,
      className
    } = this.props;

    const controlCls = classnames(classes.formControl, className);

    return (
      <FormControl className={controlCls}>
        <TextField
          name='searchValue'
          onChange={this.onChange}
          variant="standard"
          value={this.state.searchValue}
          InputProps={{
            startAdornment: <InputAdornment position="start"><SearchIcon className={classes.searchIcon} /></InputAdornment>,
            endAdornment: <IconButton aria-label="search visibility" onClick={this.onBlur} size="large"><APCloseIcon /></IconButton>
          }}
          type="text"
          inputRef={this.searchBar}
          inputProps={{ "data-testid": "search-input" }}
        />
      </FormControl>
    );
  }
}



export default withStyles(APSearchInputStyle)(APSearchInput);
